import React from "react";
import { Navigate } from "react-router-dom";

export default function OwnerRoute({ children }) {
  const isOwner = localStorage.getItem("is_owner") === "true";
  if (!isOwner) return <Navigate to="/" replace />;
  return children;
}
